import { BTTO_PROFILE_COLORS } from "./elements";

export const bettoProfileCssVariables = `
	--profile-page-wrapper-bg: transparent;
	--modal-input-bg: ${BTTO_PROFILE_COLORS.surfaceRaised};
	--input-bg-has-value: ${BTTO_PROFILE_COLORS.surfaceRaised};
	--main-explosive: ${BTTO_PROFILE_COLORS.primary};
	--main-explosive-light: ${BTTO_PROFILE_COLORS.text};
	--main-explosive-gradient: linear-gradient(180deg, ${BTTO_PROFILE_COLORS.primary} 0%, ${BTTO_PROFILE_COLORS.primaryDark} 100%);
	--main-explosive-gradient-020: rgba(3, 98, 212, 0.12);
	--secondary-text-color: ${BTTO_PROFILE_COLORS.textMuted};
	--profile-card-text-color: ${BTTO_PROFILE_COLORS.text};
	--border-color: ${BTTO_PROFILE_COLORS.primary};
	--modal-bg: ${BTTO_PROFILE_COLORS.surface};
	--header-color: ${BTTO_PROFILE_COLORS.primary};
	--content-text-color: ${BTTO_PROFILE_COLORS.text};
	--main-secondary-text-color: ${BTTO_PROFILE_COLORS.textMuted};
	--secondary-border-color: rgba(3, 98, 212, 0.2);
	--content-body-gradient: rgba(3, 98, 212, 0.12);
`;
